// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.people {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background-attachment: fixed;
  background-image: url("https://ljc-site.s3.us-east-2.amazonaws.com/img/achievement.jpeg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  opacity: 0;
  animation: FadeBkIn 1s 8s ease-in-out forwards;
}
.people_left-card {
  width: 500px;
  margin-top: 50px;
  background-color: #f7f7f7;
  height: 40rem;
  opacity: 0;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  animation: StrecthLeftOut 1s ease-in-out forwards;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media screen and (max-width: 1680px) {
  .people_left-card {
    width: 300px;
    height: 450px;
  }
}
@media (max-width: 500px) {
  .people_left-card {
    height: 25rem;
    margin: 2rem;
  }
}
.people_middle-card {
  width: 400px;
  background-color: #f7f7f7;
  height: 40rem;
  border-radius: 5px;
  -webkit-font-smoothing: antialiased;
  z-index: 1;
  transform: translateY(-1px);
  box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media screen and (max-width: 1680px) {
  .people_middle-card {
    width: 300px;
    height: 550px;
  }
}
@media (max-width: 500px) {
  .people_middle-card {
    height: 25rem;
    margin: 2rem;
  }
}
.people_right-card {
  width: 500px;
  margin-top: 50px;
  background-color: #f7f7f7;
  height: 40rem;
  opacity: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  animation: StrecthRightOut 1s ease-in-out forwards;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media screen and (max-width: 1680px) {
  .people_right-card {
    width: 300px;
    height: 450px;
  }
}
@media (max-width: 500px) {
  .people_right-card {
    height: 25rem;
    margin: 2rem;
  }
}

.section-overlay {
  position: absolute;
  top: 0;
  background-color: rgba(244, 244, 244, 0.9);
  width: 100%;
  height: 100%;
  opacity: 0;
  animation: fadeIn 1s ease-in-out forwards;
  z-index: -1;
}

@keyframes StretchLeftOut {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes StretchRightOut {
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes FadeBkIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.9;
  }
}
img {
  width: 100%;
  height: 100%;
}

.img-container {
  width: 100%;
  height: 20em;
  position: relative;
  display: flex;
  flex-direction: column;
  text-align: center;
}

.img-text-1 {
  padding: 15px;
  font-size: 1.5rem;
  font-weight: bold;
  background-color: #a5e300;
  color: #232323;
  font-family: "Spartan", sans-serif;
  text-align: center;
}

.img-text-2 {
  padding: 15px;
  font-size: 1.5rem;
  font-weight: bold;
  background-color: #337def;
  color: #232323;
  font-family: "Spartan", sans-serif;
  text-align: center;
}

.img-text-3 {
  padding: 15px;
  font-size: 1.5rem;
  font-weight: bold;
  background-color: #00ffff;
  color: #232323;
  font-family: "Spartan", sans-serif;
  text-align: center;
}

.img-description {
  padding: 20px;
  margin-top: 10px;
  font-size: 1.5rem;
  color: #232323;
  font-family: "Alegreya Sans SC", sans-serif;
}

@media screen and (max-width: 1680px) {
  .img-description {
    font-size: 1rem;
  }
}
.people-img {
  width: 100%;
  height: 100%;
  transition: all 0.5s ease-in-out;
}

.people-img:hover {
  transition: all 0.3s ease-in-out;
  transform: scale(1.055);
}

.people-card-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  padding: 50px;
}

.people-header-container {
  display: flex;
  flex-direction: column;
  margin-top: 70px;
  justify-content: center;
  align-items: center;
  padding: 50px;
}

.people-header-title {
  font-size: 1.9rem;
  /* color: #363636; */
  line-height: 1.125;
  font-weight: 700 !important;
  word-break: break-word;
  padding: 25px;
  font-family: "Spartan", sans-serif;
  color: #a5e300;
  background-color: #1d3557;
}

.people-header-arrow {
  color: #1d3557;
  font-size: 2rem;
}

.people-header-section {
  font-size: 2rem;
  line-height: 1.5;
  margin: 15px;
  color: #390879;
  width: 40em;
  text-align: center;
}

@media screen and (max-width: 1680px) {
  .people-header-section {
    width: 40em;
  }
}
@media (max-width: 1280px) {
  .people-header-section {
    width: 30em;
  }
}
@media (max-width: 500px) {
  .people-header-section {
    width: 27rem;
    font-size: 1.5rem;
  }
  .people-card-container {
    flex-direction: column;
    justify-content: center;
  }
}
.people-arrow {
  animation: arrowOut 1s 2s ease-in-out infinite;
}

@keyframes arrowOut {
  0% {
    opacity: 0;
    transform: translateY(0px);
  }
  100% {
    opacity: 1;
    transform: translateY(50px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/People-Section/People.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,yFAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,8CAAA;AACF;AACE;EACE,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,2BAAA;EACA,8BAAA;EACA,iDAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACJ;AACI;EAbF;IAcI,YAAA;IACA,aAAA;EAEJ;AACF;AAAI;EAlBF;IAmBI,aAAA;IACA,YAAA;EAGJ;AACF;AAAE;EACE,YAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,mCAAA;EACA,UAAA;EACA,2BAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAEJ;AAAI;EAbF;IAcI,YAAA;IACA,aAAA;EAGJ;AACF;AADI;EAlBF;IAmBI,aAAA;IACA,YAAA;EAIJ;AACF;AADE;EACE,YAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,UAAA;EACA,4BAAA;EACA,+BAAA;EACA,kDAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAGJ;AADI;EAbF;IAcI,YAAA;IACA,aAAA;EAIJ;AACF;AAFI;EAlBF;IAmBI,aAAA;IACA,YAAA;EAKJ;AACF;;AADA;EACE,kBAAA;EACA,MAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,yCAAA;EACA,WAAA;AAIF;;AADA;EACE;IACE,UAAA;IACA,2BAAA;EAIF;EAFA;IACE,UAAA;IACA,wBAAA;EAIF;AACF;AADA;EACE;IACE,UAAA;IACA,4BAAA;EAGF;EADA;IACE,UAAA;IACA,wBAAA;EAGF;AACF;AAAA;EACE;IACE,UAAA;IACA,2BAAA;EAEF;EAAA;IACE,UAAA;IACA,0BAAA;EAEF;AACF;AACA;EACE;IACE,UAAA;EACF;EACA;IACE,YAAA;EACF;AACF;AAEA;EACE,WAAA;EACA,YAAA;AAAF;;AAGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,kCAAA;EACA,kBAAA;AAAF;;AAEA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,kCAAA;EACA,kBAAA;AACF;;AACA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,kCAAA;EACA,kBAAA;AAEF;;AACA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,2CAAA;AAEF;;AACA;EACE;IACE,eAAA;EAEF;AACF;AACA;EACE,WAAA;EACA,YAAA;EACA,gCAAA;AACF;;AAEA;EACE,gCAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,kCAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AACF;;AAEA;EACE;IACE,WAAA;EACF;AACF;AAEA;EACE;IACE,WAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;IACA,iBAAA;EADF;EAIA;IACE,sBAAA;IACA,uBAAA;EAFF;AACF;AAKA;EACE,8CAAA;AAHF;;AAMA;EACE;IACE,UAAA;IACA,0BAAA;EAHF;EAMA;IACE,UAAA;IACA,2BAAA;EAJF;AACF","sourcesContent":[".people {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  background-attachment: fixed;\n  background-image: url(\"https://ljc-site.s3.us-east-2.amazonaws.com/img/achievement.jpeg\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n  width: 100%;\n  opacity: 0;\n  animation: FadeBkIn 1s 8s ease-in-out forwards;\n\n  &_left-card {\n    width: 500px;\n    margin-top: 50px;\n    background-color: #f7f7f7;\n    height: 40rem;\n    opacity: 0;\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n    animation: StrecthLeftOut 1s ease-in-out forwards;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    @media screen and (max-width: 1680px) {\n      width: 300px;\n      height: 450px;\n    }\n\n    @media (max-width: 500px) {\n      height: 25rem;\n      margin: 2rem;\n    }\n  }\n\n  &_middle-card {\n    width: 400px;\n    background-color: #f7f7f7;\n    height: 40rem;\n    border-radius: 5px;\n    -webkit-font-smoothing: antialiased;\n    z-index: 1;\n    transform: translateY(-1px);\n    box-shadow: 0 16px 64px 0 rgba(0, 35, 70, 0.2);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    @media screen and (max-width: 1680px) {\n      width: 300px;\n      height: 550px;\n    }\n\n    @media (max-width: 500px) {\n      height: 25rem;\n      margin: 2rem;\n    }\n  }\n\n  &_right-card {\n    width: 500px;\n    margin-top: 50px;\n    background-color: #f7f7f7;\n    height: 40rem;\n    opacity: 0;\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n    animation: StrecthRightOut 1s ease-in-out forwards;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n\n    @media screen and (max-width: 1680px) {\n      width: 300px;\n      height: 450px;\n    }\n\n    @media (max-width: 500px) {\n      height: 25rem;\n      margin: 2rem;\n    }\n  }\n}\n\n.section-overlay {\n  position: absolute;\n  top: 0;\n  background-color: rgba(244, 244, 244, 0.9);\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  animation: fadeIn 1s ease-in-out forwards;\n  z-index: -1;\n}\n\n@keyframes StretchLeftOut {\n  0% {\n    opacity: 0;\n    transform: translateX(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes StretchRightOut {\n  0% {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes FadeBkIn {\n  0% {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0.9;\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n}\n\n.img-container {\n  width: 100%;\n  height: 20em;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n}\n\n.img-text-1 {\n  padding: 15px;\n  font-size: 1.5rem;\n  font-weight: bold;\n  background-color: #a5e300;\n  color: #232323;\n  font-family: \"Spartan\", sans-serif;\n  text-align: center;\n}\n.img-text-2 {\n  padding: 15px;\n  font-size: 1.5rem;\n  font-weight: bold;\n  background-color: #337def;\n  color: #232323;\n  font-family: \"Spartan\", sans-serif;\n  text-align: center;\n}\n.img-text-3 {\n  padding: 15px;\n  font-size: 1.5rem;\n  font-weight: bold;\n  background-color: #00ffff;\n  color: #232323;\n  font-family: \"Spartan\", sans-serif;\n  text-align: center;\n}\n\n.img-description {\n  padding: 20px;\n  margin-top: 10px;\n  font-size: 1.5rem;\n  color: #232323;\n  font-family: \"Alegreya Sans SC\", sans-serif;\n}\n\n@media screen and (max-width: 1680px) {\n  .img-description {\n    font-size: 1rem;\n  }\n}\n\n.people-img {\n  width: 100%;\n  height: 100%;\n  transition: all 0.5s ease-in-out;\n}\n\n.people-img:hover {\n  transition: all 0.3s ease-in-out;\n  transform: scale(1.055);\n}\n\n.people-card-container {\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  padding: 50px;\n}\n\n.people-header-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 70px;\n  justify-content: center;\n  align-items: center;\n  padding: 50px;\n}\n\n.people-header-title {\n  font-size: 1.9rem;\n  /* color: #363636; */\n  line-height: 1.125;\n  font-weight: 700 !important;\n  word-break: break-word;\n  padding: 25px;\n  font-family: \"Spartan\", sans-serif;\n  color: #a5e300;\n  background-color: #1d3557;\n}\n\n.people-header-arrow {\n  color: #1d3557;\n  font-size: 2rem;\n}\n\n.people-header-section {\n  font-size: 2rem;\n  line-height: 1.5;\n  margin: 15px;\n  color: #390879;\n  width: 40em;\n  text-align: center;\n}\n\n@media screen and (max-width: 1680px) {\n  .people-header-section {\n    width: 40em;\n  }\n}\n\n@media (max-width: 1280px) {\n  .people-header-section {\n    width: 30em;\n  }\n}\n\n@media (max-width: 500px) {\n  .people-header-section {\n    width: 27rem;\n    font-size: 1.5rem;\n  }\n\n  .people-card-container {\n    flex-direction: column;\n    justify-content: center;\n  }\n}\n\n.people-arrow {\n  animation: arrowOut 1s 2s ease-in-out infinite;\n}\n\n@keyframes arrowOut {\n  0% {\n    opacity: 0;\n    transform: translateY(0px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(50px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
